import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

function CookiePolicy() {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, bgcolor: 'background.paper', borderRadius: 2 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: '#580100', fontWeight: 600, mb: 4 }}>
            Cookie Policy
          </Typography>

          <Typography paragraph sx={{ mb: 4 }}>
            This Cookie Policy explains how the Andheri Court's Bar Association uses cookies and similar technologies 
            to provide, customize, evaluate, improve, promote and protect our services.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            What are Cookies?
          </Typography>
          <Typography paragraph>
            Cookies are small text files that are placed on your device when you visit our website. They help us 
            provide you with a better experience by enabling basic functionalities like page navigation, 
            remembering your preferences, and helping us understand how you use our website.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Types of Cookies We Use
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Essential Cookies" 
                secondary="These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Preference Cookies" 
                secondary="These cookies remember your preferences and choices to enhance your experience on future visits."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Analytics Cookies" 
                secondary="These help us understand how visitors interact with our website by collecting and reporting information anonymously."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            How We Use Cookies
          </Typography>
          <Typography paragraph>
            We use cookies to:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Understand and save user preferences for future visits" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Keep track of user sessions and authentication" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Compile aggregate data about site traffic and site interactions" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Improve our website and user experience" />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Managing Cookies
          </Typography>
          <Typography paragraph>
            Most web browsers allow you to control cookies through their settings preferences. However, if you limit 
            the ability of websites to set cookies, you may impact your overall user experience. Some features of 
            our website may not function properly without the aid of cookies.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Changes to This Policy
          </Typography>
          <Typography paragraph>
            We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new 
            Cookie Policy on this page and updating the "last updated" date.
          </Typography>

          <Typography paragraph sx={{ mt: 4 }}>
            For any questions about our Cookie Policy, please contact us at{' '}
            <Typography component="span" sx={{ color: '#580100' }}>
              andhericourtsba@gmail.com
            </Typography>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default CookiePolicy;
